/**
 * @param {arr} array The array to dedupe
 * @param {idKey} stirng An optional id key. If passed, dedupe assumes all items are objects
 * @returns {array} Deduped array
 */
export default (arr, idKey) =>
  arr.reduce((result, item) => {
    if (idKey) {
      if (result.find(a => a[idKey] === item[idKey])) {
        return result
      }
      return [...result, item]
    } else if (result.includes(item)) {
      return result
    } else {
      return [...result, item]
    }
  }, [])
